export default "__VITE_ASSET__BaTsM2SR__"